import React, { Fragment } from 'react'
import { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { userUpdateAction, clearErrorAction, userLoadingAction } from '../../redux/actions/userAction'
import swal from 'sweetalert';
import MetaTag from '../../layout/MetaTag';

import './updateprofile.css'
import UpdateProfileImage from '../../images/undraw_Prototyping_process_re_7a6p.png';

import Loader from '../../layout/loader';
import { UPDATE_PROFILE_BY_USER_RESET } from '../../redux/constants/userConstants'


function UpdateProfile() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user)
    const { loading,error, isUpdated } = useSelector(state => state.profileUpdateByUser)

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')


    // on submit fuction 

    const userUpdateSubmitHandler = async (e) => {
        e.preventDefault();

        dispatch(userUpdateAction(firstName, lastName, email, number))
    }


    useEffect(() => {
        if(user){
            setFirstName(user.firstName)
            setLastName(user.lastName)
            setEmail(user.email)
            setNumber(user.number)
        }
        if (error) {
            swal({
                title: "Validation",
                text: error,
                icon: "error",
            })
            dispatch(clearErrorAction())
        }
        if (isUpdated) {
            swal({
                title: "Updated !!",
                text: isUpdated,
                icon: "success",
            })
            dispatch(userLoadingAction());
            history.push('/userprofile')
            dispatch({ type: UPDATE_PROFILE_BY_USER_RESET });
        }


    }, [dispatch, error, history, isUpdated, user])





    return (
        <Fragment>
            <MetaTag  title={'IM Online Shopping Update Profile Page'} />
            {loading ? <Loader /> : (<Fragment>
                <div className="update-profile-main-div">
                    <section className="update-profile-shell">
                        <div className="update-prfile-image-div">
                            <span>Account settings</span>
                            <h1>Keep your shopping profile ready</h1>
                            <p>Update your name, contact details, and account information so checkout and order updates stay smooth.</p>
                            <img src={UpdateProfileImage} alt="Update shopping profile" />
                            <div className="update-profile-highlights">
                                <span>Secure account</span>
                                <span>Fast checkout</span>
                                <span>Order updates</span>
                            </div>
                        </div>

                        <div className="update-profile-form-div">
                            <div className="update-profile-form-div-heading">
                                <span>Profile details</span>
                                <h2>Update profile</h2>
                                <p>Use the same details you want to appear on orders, delivery updates, and support requests.</p>
                            </div>
                            <form onSubmit={userUpdateSubmitHandler} >
                                <div className="update-profile-grid">
                                    <div className='first-name-div-input'>
                                        <label htmlFor="profile-first-name">First name</label>
                                        <input id="profile-first-name" type="text" placeholder='First name' value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                                    </div>

                                    <div className='first-name-div-input'>
                                        <label htmlFor="profile-last-name">Last name</label>
                                        <input id="profile-last-name" type="text" placeholder='Last name' value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                                    </div>

                                    <div className='first-name-div-input update-profile-wide-field'>
                                        <label htmlFor="profile-email">Email address</label>
                                        <input id="profile-email" type="email" placeholder='Email address' value={email} onChange={(e) => setEmail(e.target.value)} required />
                                    </div>

                                    <div className='first-name-div-input update-profile-wide-field'>
                                        <label htmlFor="profile-number">Phone number</label>
                                        <input id="profile-number" type="tel" placeholder='Phone number' value={number} onChange={(e) => setNumber(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="button-update-form-div">
                                    <Link to="/userprofile">Cancel</Link>
                                    <button>Update Profile</button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>


            </Fragment>)}

        </Fragment>
    )
}

export default UpdateProfile
